import axios from 'axios'
import { Message } from 'element-ui'
import { checkStatus } from './helper/checkStatus'

const SUCCESS_CODE = 200
const TIMEOUT = 120000

const config = {
  // 默认地址请求地址，可在 .env 文件中修改
  baseURL: process.env.VUE_APP_API_URL || '/',
  timeout: TIMEOUT,
  withCredentials: true
}

class RequestHttp {
  constructor(axiosConfig) {
    this.service = axios.create(axiosConfig)

    /**
     * @description 请求拦截器
     */
    this.service.interceptors.request.use(
      cfg => {
        // 官网公开接口默认不带鉴权；如后续需要可在这里补充 token
        return cfg
      },
      error => Promise.reject(error)
    )

    /**
     * @description 响应拦截器
     */
    this.service.interceptors.response.use(
      response => {
        const { data, config: resConfig } = response
        const isBlob =
          response.request.responseType === 'blob' && data instanceof Blob
        const isArraybuffer =
          response.request.responseType === 'arraybuffer' &&
          data instanceof ArrayBuffer

        if (
          !isBlob &&
          !isArraybuffer &&
          data.code !== undefined &&
          data.code !== SUCCESS_CODE
        ) {
          if (resConfig.showError !== false) {
            Message.error(data.message || data.msg || '请求失败')
          }
          return Promise.reject(data)
        }

        if (isBlob || isArraybuffer) {
          return { data, headers: response.headers }
        }

        return data
      },
      error => {
        const { response } = error
        if (error.message && error.message.indexOf('timeout') !== -1) {
          Message.error('请求超时！请您稍后重试')
        }
        if (error.message && error.message.indexOf('Network Error') !== -1) {
          Message.error('网络错误！请您稍后重试')
        }
        if (response) checkStatus(response.status)
        return Promise.reject(error)
      }
    )
  }

  get(url, params, _object = {}) {
    return this.service.get(url, { params, ..._object })
  }

  post(url, params, _object = {}) {
    return this.service.post(url, params, _object)
  }

  put(url, params, _object = {}) {
    return this.service.put(url, params, _object)
  }

  delete(url, params, _object = {}) {
    return this.service.delete(url, { params, ..._object })
  }
}

export default new RequestHttp(config)
